export default __webpack_public_path__ + "static/media/Test-Project.b8b8e78e.svg";